export default __webpack_public_path__ + "static/media/img10.897e0346.PNG";